import React, { FunctionComponent } from "react";
import { Chip, Grid2 } from "@mui/material";
import { Add, Done } from "@mui/icons-material";
import {
  isTeamWorkplaceSeatAssignee,
  isVisitorWorkplaceSeatAssignee
} from "./functions/form.functions";
import {
  BookingType,
  NotSerializedBookingInputs
} from "../../features/Booking-Form/typings/booking-inputs";

interface OwnProps {
  inputs: NotSerializedBookingInputs;
  currentUser: number;
  setCurrentUser: React.Dispatch<React.SetStateAction<number>>;
}

type Props = OwnProps;

const FormWorkplaceTeamBookingChips: FunctionComponent<Props> = ({
  inputs,
  currentUser,
  setCurrentUser
}) => {
  const usersToDisplay = (() => {
    if (inputs.mode === BookingType.TEAM) {
      return (
        inputs.usersBookedFor
          ?.map((user, index) => ({ user, index }))
          .filter(({ user }) => isTeamWorkplaceSeatAssignee(user)) ?? []
      );
    }

    if (inputs.mode === BookingType.VISITOR) {
      return (
        inputs.usersBookedFor
          ?.map((user, index) => ({ user, index }))
          .filter(({ user }) => isVisitorWorkplaceSeatAssignee(user)) ?? []
      );
    }

    return [];
  })();

  return (
    <Grid2 data-testid="team-member-chips-container" container>
      {usersToDisplay.map(({ user, index }) => (
        <Chip
          data-testid="team-member"
          label={user.firstName + " " + user.surname}
          style={{ margin: "0 10px 10px 0" }}
          clickable
          key={`workplace-chip-${user.userId}`}
          color={currentUser === index ? "primary" : "default"}
          onClick={() => setCurrentUser(index)}
          icon={user.bookingInventoryId === undefined ? <Add /> : <Done />}
        />
      ))}
    </Grid2>
  );
};

export default FormWorkplaceTeamBookingChips;
